import { ListItem, ListItemText, styled } from '@mui/material';

import { ReactNode } from 'react';

import { TPrototypeReviewDto } from '@app-velocity/av-api-v2';
import { Box } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { Rating } from '../Rating';
import { ReviewStatus } from './components/ReviewStatus/ReviewStatus';
import { ReviewContext } from '../../context/ReviewContext';

export type SingleReviewProps = {
  review: TPrototypeReviewDto;
  actions?: ReactNode;
};

const StyledSingleUserReview = styled(ListItem)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  border: '1px solid var(--stroke-stroke-primary-color)',
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`
}));

const ReviewData = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const UserData = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const Feedback = styled('p')({
  wordBreak: 'break-all',
  margin: '6px 0',
});

export const SingleUserReview = ({ review, actions }: SingleReviewProps) => {
  const { t } = useI18n();
  const { userName, feedback } = review;

  return (
    <ReviewContext.Provider
      value={{
        review,
      }}
    >
      <StyledSingleUserReview>
        <ListItemText>
          <ReviewData>
            <UserData>
              <strong>{userName || t('prototypes:anonymous')}</strong>
              <ReviewStatus />
            </UserData>
            <Rating />
          </ReviewData>

          <Feedback>{feedback}</Feedback>
          {actions}
        </ListItemText>
      </StyledSingleUserReview>
    </ReviewContext.Provider>
  );
};
